import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController ,MenuController} from 'ionic-angular';
import 'rxjs/add/operator/map';
import { MODO_DESCONECTADO,VERSION,NOMBRE_VERSION,DESCRIPCION_VERSION } from "../../config/url.servicio"
import { CompaniasProvider } from '../../providers/companias/companias'
import { VersionamientoProvider } from '../../providers/versionamiento/versionamiento'

@IonicPage()
@Component({
  selector: 'page-versionamiento',
  templateUrl: 'versionamiento.html',
})
export class VersionamientoPage {
  datosCommit:any[] = []
  datosCommitReal:any[] = []
  recorrerVal:any[]
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public alertControllers:AlertController,
    public servicioCompania:CompaniasProvider,
    public menuControllers:MenuController,
    public versionamientoProvider:VersionamientoProvider) {
    if(!MODO_DESCONECTADO){
      this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
      .then((val)=>{
        if(val){
          this.nombreCompaniaHeader = val['nombreCompania']
          this.nombreCargoHeader = val['nombreCargo']
        }
      })
      this.buscarValores()
 
     }else{
      this.buscarValores()
     }



  }

  buscarValores(){
    let data = this.versionamientoProvider.buscar()
    this.datosCommit = data[0]
    this.datosCommitReal = data[1]
  }

}



// WEBPACK FOOTER //
// ./src/pages/versionamiento/versionamiento.ts